import { render, staticRenderFns } from "./FormFiniquito.vue?vue&type=template&id=23b703af&"
import script from "./FormFiniquito.vue?vue&type=script&lang=js&"
export * from "./FormFiniquito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports